import { SnackbarProvider } from "notistack";

import SuccessIcon from "@/images/notifications/success.svg?react";
import ErrorIcon from "@/images/notifications/error.svg?react";
import InfoIcon from "@/images/notifications/info.svg?react";
import { useNotificationStyles } from "../styles/NotificationProvider.styles";
import { NotificationProviderProps } from "../types/Notifications.types";

// App-wide notistack setup: toast design, status icons, position and stacking.
export const NotificationProvider = ({ children, topOffset = 0 }: NotificationProviderProps) => {
  const styles = useNotificationStyles({ topOffset });

  const classes = {
    variantSuccess: styles.success,
    variantInfo: styles.info,
    variantError: styles.error,
    variantInfoPrivacy: styles.infoPrivacy,
    containerRoot: styles.containerRoot,
    message: styles.toastMessage,
  };

  return (
    <SnackbarProvider
      maxSnack={Infinity}
      classes={classes}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      iconVariant={{
        success: <SuccessIcon aria-hidden className={`${styles.toastIcon} ${styles.successIcon}`} />,
        error: <ErrorIcon aria-hidden className={`${styles.toastIcon} ${styles.errorIcon}`} />,
        info: <InfoIcon aria-hidden className={`${styles.toastIcon} ${styles.infoIcon}`} />,
      }}
    >
      {children}
    </SnackbarProvider>
  );
};
